import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {EdapProvider} from '@homeaway/react-event-tracking';
import MainComponent from '../MainComponent/MainComponent';

class RootComponent extends Component {
    static get propTypes() {
        return {
            actionLocation: PropTypes.string,
            locale: PropTypes.string.isRequired,
            site: PropTypes.string.isRequired,
            siteName: PropTypes.string.isRequired,
            service: PropTypes.string.isRequired,
            handleCloseModal: PropTypes.func,
            handleLoginSuccess: PropTypes.func,
            // The flag to disable the social login when used in the multi-user-traveler app
            multiUserEnabled: PropTypes.bool,
            expediaIconDisplayed: PropTypes.bool,
            serverConfigRendering: PropTypes.bool,
            ticketId: PropTypes.string,
            landingPage: PropTypes.string,
            marketingOptOut: PropTypes.bool
        };
    }

    static get defaultProps() {
        return {
            actionLocation: '-1',
            locale: 'en_US_VRBO',
            site: 'vrbo',
            siteName: 'Vrbo',
            service: 'misconfigured'
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            defaultFields: {actionlocation: this.props.actionLocation},
            defaultOptions: {delayProcessing: 'true'}
        };
    }

    render() {
        const props = this.props;
        return (
            <EdapProvider fields={this.state.defaultFields} options={this.state.defaultOptions}>
                <MainComponent {...props}/>
            </EdapProvider>
        );
    }
}

export default RootComponent;
